export default __webpack_public_path__ + "static/media/bag.122737bc.png";